<template>
    <div class="share">
        <a href="#" class="fa fa-facebook" @click="shareToFacebook">Share</a>
        <!--<a :href="`https://twitter.com/intent/tweet?text=${encodedSocialShareText}&url=https://play.99math.com/${celebrityInvite}pic.html?share=twitter&hashtags=99math`"
           class="fa fa-twitter"
           target="_blank"
        >Tweet</a>
        <br />-->
        <a href="#" class="fa fa-instagram" @click="shareToInstagram"></a>
    </div>
</template>

<script>
    export default {
        props: {
            totalScore: {
                type: Number,
                required: true,
            },
            showShareWidget: {
                type: Boolean,
                required: false,
                default: false,
            },
            gameResult: {
                type: String,
                required: true,
            },
            invitePoints: {
                type: Number,
                required: false,
            },
            friendName: {
                type: String,
                required: false,
            },
            celebrityInvite: {
                type: String,
                required: false,
            },
        },
        computed: {
            socialShareText() {
                return `${this.friendName} got ${this.invitePoints} points and I got ${this.totalScore} points! How many can you get?`;
            },
            encodedSocialShareText() {
                return encodeURI(this.socialShareText);
            }
        },
        mounted() {
            window.fbAsyncInit = function () {
                FB.init({
                    appId: '2441715959206374',
                    autoLogAppEvents: true,
                    xfbml: true,
                    version: 'v3.3'
                })
                FB.AppEvents.logPageView()
            };

            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0]
                if (d.getElementById(id)) { return }
                js = d.createElement(s); js.id = id
                js.src = 'https://connect.facebook.net/en_US/sdk.js'
                fjs.parentNode.insertBefore(js, fjs)
            }(document, 'script', 'facebook-jssdk'))
        },
        methods: {
            shareToFacebook() {
                FB.ui({
                    method: 'share',
                    //href: `${location.protocol}//${location.host}`,
                    href: `https://play.99math.com/${this.celebrityInvite}.html?share=fb`,
                    quote: this.socialShareText,
                    hashtag: '#99math',
                }, function(response){
                    console.log(response)
                });
            },
            shareToInstagram() {
                this.$router.push({
                    name: 'insta-share',
                    params: {
                        celebrityInvite: this.celebrityInvite,
                        friendName: this.friendName,
                    }
                });
            }
        }

    }
</script>

<style lang="scss" scoped>
.share {
    display: flex;
    justify-content: center;
    vertical-align: center;
}
.fa {
    padding: 12px 20px;
    font-size: 20px;
    text-align: center;
    text-decoration: none;
    border-radius: 0.5rem;
    margin: 5px;
    &::before {
        padding-right: 5px;
    }
    &:hover {
        opacity: 0.7;
    }
    &-facebook {
        background: #3B5998;
        color: white;
    }
    &-twitter {
        background: #55ACEE;
        color: white;
    }
    &-instagram {
        background: #D56297;
        color: white;
        font-size: 35px;
        padding: 5px 0 5px 7px;
    }
}
</style>
